import React from "react";
import { RefreshCw, Home } from "lucide-react";

export function GameOverModal({ wave, highScore, onRestart, onReturnToMenu }: { wave: number, highScore: number, onRestart: () => void, onReturnToMenu: () => void }) {
  const isNewHighScore = wave > highScore;

  return (
    <div className="absolute inset-0 bg-black/60 flex items-center justify-center pointer-events-auto">
      <div className="bg-gray-800 p-8 rounded-xl shadow-2xl text-center text-white border-2 border-gray-700 min-w-[350px]">
        <h1 className="text-5xl font-bold mb-4">Game Over</h1>
        <p className="text-xl mb-2">{`You survived until wave ${wave}.`}</p>
        <div className="text-lg mb-8">
          {isNewHighScore ? (
            <p className="text-yellow-400 animate-pulse">New High Score!</p>
          ) : (
            <p className="text-gray-400">{`Highest Wave: ${highScore}`}</p>
          )}
        </div>
        <div className="flex flex-col items-center gap-4 w-full">
            <button
              onClick={onRestart}
              className="w-full flex items-center justify-center gap-3 bg-yellow-500 hover:bg-yellow-600 text-gray-900 font-bold py-3 px-8 rounded-lg text-2xl transition-transform transform hover:scale-105"
            >
              <RefreshCw />
              Restart
            </button>
            <button
              onClick={onReturnToMenu}
              className="w-full flex items-center justify-center gap-3 bg-gray-600 hover:bg-gray-500 text-white font-bold py-2 px-6 rounded-lg text-xl transition-transform transform hover:scale-105"
            >
              <Home className="w-6 h-6" />
              Main Menu
            </button>
        </div>
      </div>
    </div>
  );
}
